import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import { Box,Typography, Grid, useMediaQuery } from "@mui/material";
import { cityJson } from "../utils/CityJson";

const CityPopup = ({getItemId,openPop}) => {

  const isSmallScreen = useMediaQuery("(max-width:600px)");



  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openPop}
      >
        <Box
          sx={{
            height: "auto",
            width: isSmallScreen ? '90%' : '60%',
            maxHeight: isSmallScreen ? '80vh' : 'auto', // limit height on mobile
            background: "white",
            overflowY: isSmallScreen ? "auto" : "visible", // scroll on mobile if content exceeds
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexGrow: 1,
                flexShrink: 1,
                justifyContent: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
 
<Box  sx={{
                  position: "absolute",
                  top: isSmallScreen ? "2px" :"20px",
                  zIndex: 10,
                  color:"black"
                }}>
    <Typography sx={{fontSize:"14px"}}>Choose City</Typography>
</Box>
              <Grid container spacing={2} sx={{ p: isSmallScreen ? "20px" : "70px", textAlign: "center" }}>
                {cityJson.map((item) => (
                  <Grid item key={item.id} xs={6} sm={3} onClick={()=>getItemId(item.id)}>
                    <img
                      srcSet={`${item.url}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.url}?w=164&h=164&fit=crop&auto=format`}
                      alt={item.cityName}
                      style={{ width:isSmallScreen? "70px":"100px", height:isSmallScreen? "70px": "100px",cursor:'pointer' }}
                      loading="lazy"
                    />
                    {/* <Typography variant="h6" sx={{ color: "#000", textAlign: "center",fontSize:"14px" }}>
                      {item.cityName}
                    </Typography> */}
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Backdrop>
    </div>
  );
};

export default CityPopup;
